<template>
  <v-data-table
      :items="cards"
      hide-actions
      hide-headers
      class="account-cards"
      :no-data-text="$tf('Add a card pressing \'+\'')"
  >
    <template slot="items" slot-scope="props">
      <td v-if="source !== null">
        <v-checkbox
            :input-value="source === props.item.id"
            @click.native="$emit('update:source', props.item.id)"
        ></v-checkbox>
      </td>
      <td>
        <i class="pw" :class="brand(props.item.brand)" v-if="brand(props.item.brand) !== ''"></i>
        <v-icon v-else>credit_card</v-icon>
      </td>
      <td class="text-xs-right"><span class="card-number">{{padding(props.item.brand)}}{{ props.item.last4 ? props.item.last4 : '••••'}}</span>
      </td>
      <td class="text-xs-right">{{ props.item.exp_month }} / {{ props.item.exp_year }}</td>
      <td class="text-xs-right" v-if="source === null">
        <v-chip outline small color="blue" v-if="props.item.default">
          <v-icon left color="blue">star</v-icon>
          Default
        </v-chip>
      </td>
      <td class="text-xs-right" v-if="$listeners && $listeners.delete">
        <v-btn flat icon @click="remove(props.item.id)">
          <v-icon>delete</v-icon>
        </v-btn>
      </td>
      <td class="text-xs-right">
        <v-spacer></v-spacer>
      </td>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: 'account-cards',
    props: {
      cards: {
        type: Array,
        default: []
      },
      source: {
        type: String,
        default: null
      }
    },
    data () {
      return {}
    },
    methods: {
      padding (brand) {
        switch (brand) {
          case 'American Express':
            return '••••  ••••••  •'
          case 'Diners Club':
            return '••••  ••••  ••'
          default :
            return '••••  ••••  ••••  '
        }
      },
      brand (brand) {
        switch (brand) {
          case 'American Express':
            return 'pw-american-express'
          case 'Diners Club':
            return 'pw-diners'
          case 'Discover':
            return 'pw-discover'
          case 'JCB':
            return 'pw-jcb'
          case 'MasterCard':
            return 'pw-mastercard'
          case 'UnionPay':
            return 'pw-unionpay'
          case 'Visa':
            return 'pw-visa'
          default :
            return ''
        }
      },
      remove (id) {
        this.$emit('delete', id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .pw {
    font-size: 28px;
    color: gray;
    vertical-align: middle;
  }

  .card-number {
    font-family: monospace;
    color: #0a0a0a;
    font-weight: bold;
  }

  .account-cards {
    max-width: 750px;
  }
</style>



// WEBPACK FOOTER //
// src/components/stripe/CardList.vue